import React from 'react';

function MobilePhone(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M15.1258 2H8.87582C7.14981 2 5.75082 3.39899 5.75082 5.125V18.875C5.75082 20.601 7.14981 22 8.87582 22H15.1258C16.8518 22 18.2508 20.601 18.2508 18.875V5.125C18.2508 3.39899 16.8518 2 15.1258 2ZM17.0008 17V5.125C17.0008 4.08934 16.1615 3.25 15.1258 3.25H8.87582C7.84017 3.25 7.00082 4.08934 7.00082 5.125V17H17.0008ZM7.00082 18.25H17.0008V18.875C17.0008 19.9107 16.1615 20.75 15.1258 20.75H8.87582C7.84017 20.75 7.00082 19.9107 7.00082 18.875V18.25Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default MobilePhone;
